import LegalPage from "@/components/LegalPage";

export default function Resiliation() {
  return (
    <LegalPage title="Résiliation & remboursements" updatedAt="2026-02-15" testid="page-resiliation">
      <p className="text-slate-400 italic">
        RevenueFix AI est un service SaaS destiné exclusivement aux professionnels. Les règles
        ci-dessous s'inscrivent dans le cadre d'un contrat conclu entre professionnels.
      </p>

      <h2>Résiliation à tout moment</h2>
      <p>
        Votre abonnement RevenueFix AI est <strong>sans engagement</strong> et peut être résilié à
        tout moment.
      </p>
      <p>
        Pour résilier : rendez-vous sur votre <a href="/dashboard">Dashboard</a> puis cliquez sur
        « Gérer mon abonnement » — vous serez redirigé vers le portail sécurisé Stripe où vous
        pourrez annuler le renouvellement en un clic.
      </p>

      <h2>Effets de la résiliation</h2>
      <ul>
        <li>La résiliation empêche le prochain prélèvement mensuel.</li>
        <li>Votre accès aux fonctionnalités payantes est <strong>maintenu jusqu'à la fin de la période déjà payée</strong>.</li>
        <li>À cette échéance, votre compte repasse automatiquement au forfait Free.</li>
        <li>Vos audits, rapports et PDF existants <strong>ne sont pas supprimés</strong>.</li>
      </ul>

      <h2>Remboursements</h2>
      <p>
        Une résiliation seule <strong>n'entraîne pas automatiquement</strong> le remboursement de la
        période mensuelle en cours, celle-ci ayant déjà été facturée et le Service étant pleinement
        disponible jusqu'à son échéance.
      </p>
      <p>
        Aucune stipulation des présentes ne saurait écarter une disposition légale impérative
        éventuellement applicable. En cas de facturation erronée ou d'indisponibilité majeure
        prolongée imputable au Prestataire, une demande peut être adressée à
        <a href="mailto:damienallais3@gmail.com"> damienallais3@gmail.com</a> en précisant l'email
        de compte et la période concernée.
      </p>

      <h2>Support</h2>
      <p>
        Une question sur votre facturation ou votre résiliation ? Écrivez à
        <a href="mailto:damienallais3@gmail.com"> damienallais3@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
